import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EmployeeContactUserResolver } from './../users/services/user.resolver.service';
import { KubaExportModule } from './../shared/kuba-exports/kuba-export.module';
import { PortalActivityNewComponent } from './components/portal-activity-new.component';
import { ActivityNewComponent } from './components/activity-new.component';
import {
  RiskListResolver,
  CompanyNameFastResolver
} from './../businesses/services/business.resolver.service';
import { EcplTabNavigationModule } from 'src/app/shared/ecpl-tab-navigation/ecpl-tab-navigation.module';
import { EcplDocumentExplorerModule } from './../../shared/ecpl-document-explorer/ecpl-document-explorer.module';
import { EmployeeDocResolver } from './../employees/services/employee.resolver.service';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DeviationEditResolver } from '../deviation/services/deviation.resolver';
import {
  RiskAnalysisTopicCachedResolver,
  RiskAnalysisEditResolver,
  RiskAnalysisListResolver,
  RiskAnalysisDepartmentResolver,
  BusinessesListResolver,
  ApprovalNoticesResolver,
  RiskAnalysisLogResolver,
  RiskAnalysisAdminResolver,
  RiskAttachmentResolver,
  RiskAnalysisTopicForAdminResolver,
  FollowupDepartmentForAdminResolver,
  UserForAdminResolver,
  RiskAnalysisCategoryResolver
} from './services/risk-analysis.resolver.service';
import {
  FollowupDeviationListResolver,
  FollowupTopicResolver,
  AllDepartmentCachedResolver,
  FollowupCaseTypeResolver,
  BusinessResolver,
  ClientResolver,
  ResponsibleForExecutionResolver,
  DeviationsByUserResolver,
  EmployeeContactsListResolver,
  AllDepartmentResolver,
  DeviationUserResolver,
  DepartmentsByBusinessIdResolver,
  BusinessLevelTopicResolver,
  FollowupCaseTypeByBusinessIdResolver,
  ModuleObjectDropdownResolver
} from './services/deviation.resolver.service';
import {
  ActivityEditResolver,
  ResponsiblePersonListResolver,
  RepetionListResolver,
  DepartmentCachedListResolver,
  ChecklistResolver,
  ActiveBusinessResolver,
  PortalActivityEditResolver,
  PortalActivityDepartmentsResolver,
  PortalActivityUsersResolver,
  PortalActivityChecklistResolver
} from './services/activities.resolver.service';
import { ActivityServices } from './services/activities.services';
import { AppSharedModule } from './../shared/appShared.module';
import { RiskanalysisService } from './services/risk-analysis.service';
import { DeviationServices } from './services/deviation.services';
import { UserService } from './../users/services/user.service';
import { FollowUpsComponent } from './followups.component';
import {
  FollowUpActivitiesComponent,
  FollowUpDeviationComponent,
  MeetingCalendarComponent,
  DepartmentComponent,
  TopicComponent,
  uploadComponent,
  EditActivitiesComponent,
  ActivityListComponent,
  NewRiskAnalysisComponent,
  RiskAnalysisListComponent,
  RiskAnalysisComponent,
  DeviationListComponent,
  AddDeviationComponent,
  viewlogComponent,
  NewRiskPortalComponent
} from './components/index';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { ArchiveTreeDataResolver } from '../archive/archive.resolver.service';
import { EcplDocumentTreeModule } from 'src/app/shared/ecpl-document-tree/ecpl-document-tree.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ContactServices } from '../contact/services/contact.service';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, SharedModule } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputNumberModule } from 'primeng/inputnumber';
import { PaginatorModule } from 'primeng/paginator';
import { FieldsetModule } from 'primeng/fieldset';
import { PopoverModule } from 'primeng/popover';
import { RiskanalysisListChartComponent } from './components/riskanalysis-list-chart/riskanalysis-list-chart.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DeviationListChartsComponent } from './components/deviation-list-charts/deviation-list-charts.component';
import { ActivityListChartComponent } from './components/activity-list-chart/activity-list-chart.component';
import { TranslateColumnPipe } from './pipes/translate-column.pipe';
import { DeviationQrGeneratorComponent } from './components/deviation-qr-generator/deviation-qr-generator.component';
import { QRCodeComponent } from 'angularx-qrcode';

@NgModule({
  imports: [
    CommonModule,
    AppSharedModule,
    RouterModule,
    TranslatePipe, TranslateDirective,
    ConfirmDialogModule,
    PopoverModule,
    TableModule,
    SharedModule,
    DialogModule,
    DatePickerModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    TextareaModule,
    InputTextModule,
    TranslatePipe, TranslateDirective,
    AppSharedModule,
    RouterModule,
    ButtonModule,
    FileUploadModule,
    MultiSelectModule,
    EcplTabNavigationModule,
    FieldsetModule,
    InputNumberModule,
    PaginatorModule,
    KubaExportModule,
    EcplDocumentExplorerModule,
    EcplDocumentTreeModule,
    ModalModule,
    NgxChartsModule,
    QRCodeComponent
  ],
  exports: [
    FollowUpsComponent,
    MeetingCalendarComponent,
    FollowUpDeviationComponent,
    NewRiskAnalysisComponent,
    DepartmentComponent,
    TopicComponent,
    uploadComponent,
    EditActivitiesComponent,
    ActivityListComponent,
    NewRiskAnalysisComponent,
    RiskAnalysisComponent,
    RiskAnalysisListComponent,
    DeviationListComponent,
    AddDeviationComponent,
    viewlogComponent,
    NewRiskPortalComponent,
    ActivityNewComponent,
    PortalActivityNewComponent
  ],
  declarations: [
    FollowUpsComponent,
    MeetingCalendarComponent,
    FollowUpActivitiesComponent,
    FollowUpDeviationComponent,
    NewRiskAnalysisComponent,
    DepartmentComponent,
    TopicComponent,
    uploadComponent,
    EditActivitiesComponent,
    ActivityListComponent,
    NewRiskAnalysisComponent,
    RiskAnalysisComponent,
    RiskAnalysisListComponent,
    DeviationListComponent,
    AddDeviationComponent,
    viewlogComponent,
    NewRiskPortalComponent,
    ActivityNewComponent,
    PortalActivityNewComponent,
    RiskanalysisListChartComponent,
    DeviationListChartsComponent,
    ActivityListChartComponent,
    TranslateColumnPipe,
    DeviationQrGeneratorComponent
  ],
  providers: [
    ActivityServices,
    DeviationServices,
    ConfirmationService,
    RiskanalysisService,
    DeviationEditResolver,
    ActivityEditResolver,
    RiskAnalysisTopicCachedResolver,
    RiskAnalysisEditResolver,
    RiskAnalysisListResolver,
    RiskAnalysisDepartmentResolver,
    FollowupDeviationListResolver,
    FollowupTopicResolver,
    AllDepartmentCachedResolver,
    FollowupCaseTypeResolver,
    BusinessResolver,
    ClientResolver,
    ResponsibleForExecutionResolver,
    ResponsiblePersonListResolver,
    RepetionListResolver,
    DeviationsByUserResolver,
    BusinessesListResolver,
    DepartmentCachedListResolver,
    EmployeeContactsListResolver,
    EmployeeDocResolver,
    ApprovalNoticesResolver,
    ArchiveTreeDataResolver,
    ChecklistResolver,
    EmployeeContactUserResolver,
    RiskAnalysisLogResolver,
    RiskAnalysisAdminResolver,
    RiskAttachmentResolver,
    RiskAnalysisTopicForAdminResolver,
    FollowupDepartmentForAdminResolver,
    UserForAdminResolver,
    AllDepartmentResolver,
    ContactServices,
    ActiveBusinessResolver,
    DeviationUserResolver,
    RiskListResolver,
    RiskAnalysisCategoryResolver,
    CompanyNameFastResolver,
    PortalActivityEditResolver,
    PortalActivityDepartmentsResolver,
    PortalActivityUsersResolver,
    PortalActivityChecklistResolver,
    DepartmentsByBusinessIdResolver,
    BusinessLevelTopicResolver,
    FollowupCaseTypeByBusinessIdResolver,
    ModuleObjectDropdownResolver
  ]
})
export class FollowUpsModule {}
